import Icon from '@mdi/react'
import {WarningPatientEmptyDataStyled} from './WarningPatientEmptyDataStyled'
import {mdiAlert} from '@mdi/js'

const WarningPatientEmptyData: React.FC<{message: string}> = ({message}) => {
  return (
    <WarningPatientEmptyDataStyled>
      <Icon path={mdiAlert} size={1} style={{color: '#ffc53d'}} />
      <div>{message}</div>
    </WarningPatientEmptyDataStyled>
  )
}

export default WarningPatientEmptyData
